import React from "react";
import CustomPagination from "./CustomPagination";

const PAGE_SIZES = [5, 10, 20, 50];

type PagedHistoryProps = {
    title: string;
    items: any[];
    pageSize: number;
    currentPage: number;
    onPageChange: (page: number) => void;
    onPageSizeChange: (size: number) => void;
    renderTable: (pageItems: any[]) => React.ReactNode;
};

const PagedHistory = ({title, items, pageSize, currentPage, onPageChange, onPageSizeChange, renderTable}: PagedHistoryProps) => {
    const total = items.length;
    const nPages = Math.max(1, Math.ceil(total / pageSize));
    const page = Math.min(currentPage, nPages);
    const first = (page - 1) * pageSize;
    const last = Math.min(first + pageSize, total);

    return (
        <div className="ktm-paged-history">
            <div className="ktm-paged-history-header">
                <div className="ktm-paged-history-title">{title}</div>
                <select
                    className="form-select ktm-paged-history-size"
                    value={pageSize}
                    onChange={(e) => onPageSizeChange(Number(e.target.value))}
                >
                    {PAGE_SIZES.map((size) => (
                        <option key={size} value={size}>
                            {size} per page
                        </option>
                    ))}
                </select>
            </div>
            {total === 0 ? (
                <div className="ktm-paged-history-empty">No entries</div>
            ) : (
                <>
                    {renderTable(items.slice(first, last))}
                    <div className="ktm-paged-history-footer">
                        <span>
                            Showing {first + 1} - {last} of {total} entries
                        </span>
                        {nPages > 1 && (
                            <CustomPagination nPages={nPages} currentPage={page} setCurrentPage={onPageChange}/>
                        )}
                    </div>
                </>
            )}
        </div>
    );
};

export default PagedHistory;
